import { nanoid } from 'nanoid'
import React from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { MessageContent } from 'widgets/TemplateActions/ui/MessageContent/MessageContent.tsx'
import {
  EmojiAction,
  mergeFieldReplacer,
  MessageFieldStore,
  ShortenLinkAction,
} from 'widgets/MessageField'
import { type IAddContactNoteActionProps } from 'widgets/TemplateActions/addContactNote/addContactNote.tsx'
import { MergeFieldsIconAction } from 'widgets/MergeField/ui/actions/MergeFieldsIconAction/MergeFieldsIconAction.tsx'

export const sendSMS = (props: IAddContactNoteActionProps, entities: IEntitiesStore) => {
  const id = nanoid()
  const messageFieldStore = new MessageFieldStore(
    {
      placeholder: 'Write your message...',
      textLimit: { maxLength: 160, message: 'SMS can contain max 160 characters' },
      styles: { minHeight: 102 },
      makeActions: () => [
        { iconButtonComponent: <EmojiAction /> },
        {
          iconButtonComponent: (
            <MergeFieldsIconAction
              onAddMergeField={(value) => {
                if (!messageFieldStore.addContent) return
                messageFieldStore.addContent(
                  mergeFieldReplacer(entities, value.template) + '&nbsp;'
                )
              }}
              isAllIntegration
            />
          ),
        },
        { iconButtonComponent: <ShortenLinkAction /> },
      ],
    },
    entities
  )
  modalStore.addModal({
    id,
    title: 'Send SMS',
    pureContent: true,
    ModalContent: () => (
      <MessageContent
        onClose={() => modalStore.closeModal(id)}
        questionInfoTooltip={'Agent will write this message based on the conversation'}
        title={'Let AI write this message '}
        messageFieldStore={messageFieldStore}
        {...props}
      />
    ),
  })
}
